export class StateMappingInfo {
  Id: number
  CycleCode: string
  CycleName: string
  StateCode: string
  StateName: string
  SubStateCode: string
  SubStateName: string
  FlagDelete: string
  FlagActive: string = "Y"
  CreateBy: string
  CreateByDisplay: string
  CreateDate: string
  UpdateBy: string
  UpdateByDisplay: string
  UpdateDate: string
}
